import {
    FETCH_COMPETENCES_GENERIQUES_SUCCESS,
    FETCH_COMPETENCES_GENERIQUES_FAIL,
    CREATE_COMPETENCE_GENERIQUE_SUCCESS,
    CREATE_COMPETENCE_GENERIQUE_FAIL,
    UPDATE_COMPETENCE_GENERIQUE_SUCCESS,
    UPDATE_COMPETENCE_GENERIQUE_FAIL,
    DELETE_COMPETENCE_GENERIQUE_SUCCESS,
    DELETE_COMPETENCE_GENERIQUE_FAIL,
    SET_COMPETENCES_GENERIQUES_LOADING,
} from "../actions/competencesGeneriquesActions";

const initialState = {
    competencesGeneriques: [],
    loading: false,
    error: null,
};

const competencesGeneriquesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_COMPETENCES_GENERIQUES_LOADING:
            return { ...state, loading: action.payload };

        case FETCH_COMPETENCES_GENERIQUES_SUCCESS:
            return { ...state, competencesGeneriques: action.payload, error: null };

        case FETCH_COMPETENCES_GENERIQUES_FAIL:
        case CREATE_COMPETENCE_GENERIQUE_FAIL:
        case UPDATE_COMPETENCE_GENERIQUE_FAIL:
        case DELETE_COMPETENCE_GENERIQUE_FAIL:
            return { ...state, error: action.payload };

        case CREATE_COMPETENCE_GENERIQUE_SUCCESS:
            return {
                ...state,
                competencesGeneriques: [...state.competencesGeneriques, action.payload],
                error: null,
            };

        case UPDATE_COMPETENCE_GENERIQUE_SUCCESS:
            return {
                ...state,
                competencesGeneriques: state.competencesGeneriques.map((c) =>
                    c.id === action.payload.id ? action.payload : c
                ),
                error: null,
            };

        case DELETE_COMPETENCE_GENERIQUE_SUCCESS:
            return {
                ...state,
                competencesGeneriques: state.competencesGeneriques.filter((c) => c.id !== action.payload.id),
                error: null,
            };

        default:
            return state;
    }
};

export default competencesGeneriquesReducer;
